import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Tip, TipCreate, TipFilter } from '../data/tip';

export function createTipService(client: AxiosInstance) {
  return createCrudService<Tip, TipCreate, TipFilter>(
    client,
    '/restaurant/Tip',
    'id',
  );
}

export type TipService = CrudService<Tip, TipCreate, TipFilter>;
